import Regexes from "./regexes";

export default Regexes;